<p>Connessione con il server interrotta. Si prega di rifare il login.</p>
<p></p>
<button id="close-button" type="button" mat-stroked-button color="primary" [mat-dialog-close]
        cdkFocusInitial>{{ 'Multilang.close' | translate }}</button>
